import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';
import Navbar from '../../../Header/Navbar'
import NavbarSecond from '../../../Header/NavbarSecond'
import MobileNavbar from '../../../Header/MobileNavbar'
import Footer from '../../../Footer/Footer'
import PillarVideosDetailsContent from './PillarVideosContent/PillarVideosDetailsContent';
import { useParams } from 'react-router-dom';
import { getPillarsVideoData } from '../../../../Redux/Action/Action';
import PillarVideosDetailsBanner from './PillarVideoDetailsBanner/PillarVideosDetailsBanner';

const PillarVideoDetails = () => {

    const dispatch = useDispatch();

    useEffect(() => {

        if (!name) {
            toast.error("No such pillar");
            navigate(-1)
        } else {


            dispatch(getPillarsVideoData(name));
        }
    }, []);




    const { name } = useParams();
    const navigate = useNavigate();

    let [banner,setBanner] = useState("");

    const pillarsVideoData = useSelector((state) => (state?.Reducer) ? (state?.Reducer?.pillarsVideoDataList?.data) : []);
    // const Banner = pillarsVideoData?.banner;

    useEffect(()=>{
        if(pillarsVideoData){
            // console.log(pillarsVideoData)
            let bannerdata = pillarsVideoData?.banner;
            if(bannerdata){
                setBanner(bannerdata);
            }
        }
    },[pillarsVideoData])


    return (
        <>
            <Navbar />
            <NavbarSecond />
            <MobileNavbar />
            <PillarVideosDetailsBanner Banner={banner} />
            <PillarVideosDetailsContent pillarsVideoData={pillarsVideoData} />
            <Footer />
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </>
    )
}

export default PillarVideoDetails